import type { PickKey } from '@packages/types/types';
import { MFNames } from './MFNames';
import type { Stands } from './Stands';

export type AppHostNames = PickKey<
	typeof MFNames,
	| 'efr'
	| 'efrFast'
	| 'efrDrom'
	| 'efrT2'
	| 'reki'
	| 'seller'
	| 'efrAdmin'
	| 'webStaticAdmin'
>;

export const appHostMfs: Record<AppHostNames, AppHostNames> = {
	[MFNames.efr]: MFNames.efr,
	[MFNames.efrAdmin]: MFNames.efrAdmin,
	[MFNames.efrFast]: MFNames.efrFast,
	[MFNames.efrDrom]: MFNames.efrDrom,
	[MFNames.efrT2]: MFNames.efrT2,
	[MFNames.reki]: MFNames.reki,
	[MFNames.seller]: MFNames.seller,
	[MFNames.webStaticAdmin]: MFNames.webStaticAdmin,
} as const;

export const appHosts: {
	[appHost in AppHostNames]: Record<Stands, string>;
} = {
	efr: {
		test: 'https://efrtest.ru',
		cert: 'https://efrcert.ru',
		prod: 'https://efr.ru',
	},
	efrAdmin: {
		test: 'https://admin.efrtest.ru',
		cert: 'https://admin.efrcert.ru',
		prod: 'https://admin.efr.ru',
	},
	efrFast: {
		test: 'https://fast.efrtest.ru',
		cert: 'https://fast.efrcert.ru',
		prod: 'https://fast.efr.ru',
	},
	efrDrom: {
		test: 'https://drom.efrtest.ru',
		cert: 'https://drom.efrcert.ru',
		prod: 'https://drom.efr.ru',
	},
	efrT2: {
		test: 'https://t2.efrtest.ru',
		cert: 'https://t2.efrcert.ru',
		prod: 'https://t2.efr.ru',
	},
	reki: {
		test: 'https://reki.efintest.ru',
		cert: 'https://reki.efincert.ru',
		prod: 'https://reki.efin.ru',
	},
	seller: {
		test: 'https://seller.efintest.ru',
		cert: 'https://seller.efincert.ru',
		prod: 'https://seller.efin.ru',
	},
	webStaticAdmin: {
		test: 'https://web-static-admin.efrtest.ru',
		cert: 'https://web-static-admin.efrcert.ru',
		prod: 'https://web-static-admin.efr.ru',
	},
};
export type EfrAppNames = PickKey<
	typeof appHostMfs,
	'efr' | 'efrFast' | 'efrDrom' | 'efrT2'
>;
